<template>
	<div class="cast-list">
		<form @submit.prevent="search">
			<ManagingSection :columnCount="3">
				<ManagingBox title="카테고리">
					<Selector
						v-model="idPouchCategory"
						:optionList="castCateList"
						valueKey="id"
					/>
				</ManagingBox>
				<ManagingBox title="등록일">
					<DateRange v-model="period" type="date" />
				</ManagingBox>
				<ManagingBox title="노출 상태">
					<Selector
						v-model="displayState"
						:optionList="displayStateList"
					/>
				</ManagingBox>
				<ManagingBox title="검색">
					<Selector
						v-model="searchType"
						:optionList="searchTypeList"
					/>
					<input v-model="searchText" type="text" />
				</ManagingBox>
				<ManagingBox title="등록자">
					<Selector
						v-model="idRegister"
						:optionList="castAdminList"
						valueKey="id"
					/>
				</ManagingBox>
				<ManagingBox title="태그">
					<input v-model="tags" type="text" />
				</ManagingBox>
			</ManagingSection>
			<ManagingSection
				:columnCount="3"
				:diminishable="true"
				:splice="true"
				class="cast-list__filter-section-2"
			>
				<ManagingBox title="제품">
					<Selector
						v-model="pdtSearchType"
						:optionList="pdtSearchTypeList"
					/>
					<input v-model="pdtSearchText" type="text" />
				</ManagingBox>
				<ManagingBox title="브랜드">
					<SearchBrand ref="SearchBrand" @change="idBrandChange" />
				</ManagingBox>
				<ManagingBox title="제품 카테고리">
					<CategorySelector
						ref="CategorySelector"
						@change="categoryChange"
					/>
				</ManagingBox>
			</ManagingSection>
			<div class="btn-wrap-main">
				<button type="submit" class="btn-main blue" v-text="'검색'" />
				<button
					type="button"
					class="btn-main blue bordered"
					v-text="'초기화'"
					@click="init"
				/>
			</div>
		</form>
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left cast-list__status">
					{{ parsedStatus }}
					<p class="section__info__text">
						- Drag & Drop으로 전시순서 변경이 가능합니다.
					</p>
				</div>
				<div class="section__info__right">
					<button
						class="btn btn-excel"
						v-text="'EXCEL 다운'"
						@click="downExcel"
					/>
					<Selector
						v-model="sort"
						:optionList="sortList"
						class="section__info__items"
						@input="sortChange"
					/>
					<Selector
						v-model="limit"
						:optionList="limitList"
						class="section__info__items"
						@input="search(0)"
					/>
				</div>
			</template>

			<table class="table-main">
				<thead>
					<tr>
						<th
							v-for="item in thList"
							:key="item.id"
							:class="`cast-list__table-cell--${item.id}`"
						>
							<SortHeader
								v-if="item.descValue && item.ascValue"
								v-model="sort"
								:label="item.text"
								:descValue="item.descValue"
								:ascValue="item.ascValue"
								@input="sortChange"
							/>
							<template v-else>{{ item.text }}</template>
						</th>
					</tr>
				</thead>
				<Draggable v-model="list" tag="tbody" @end="endDrag()">
					<tr v-for="tdList in list" :key="tdList[0].conts">
						<td
							v-for="td in tdList"
							:key="td.id"
							:class="`cast-list__table-cell--${td.id}`"
						>
							<img v-if="td.src" :src="td.src" />
							<router-link
								v-else-if="td.link"
								class="link"
								:to="td.link"
								>{{ td.conts }}</router-link
							>
							<button
								v-else-if="td.hasOwnProperty('btnTxt')"
								:disabled="!td.btnTxt"
								class="btn"
								@click="
									clickCellBtn(
										td.id,
										tdList[0].conts,
										tdList[3].conts
									)
								"
								v-text="td.btnTxt"
							/>
							<button
								v-else-if="td.id === 'duplicate'"
								class="btn orange"
								@click="duplicate(tdList[0].conts)"
								v-text="'복제'"
							/>
							<button
								v-else-if="td.id === 'delete'"
								class="btn red"
								@click="deleting(tdList[0].conts)"
								v-text="'삭제'"
							/>
							<template v-else>{{ td.conts }}</template>
							<button
								v-if="td.id === 'cnt'"
								:disabled="!td.btnTxt"
								class="btn cast-list__daily-button"
								@click="clickCellBtn('daily', tdList[0].conts)"
								v-text="'날짜별 조회수'"
							/>
						</td>
					</tr>
				</Draggable>
			</table>
			<PaginationBox
				:totalItem="total"
				:offset="offset"
				:limit="limit"
				:pageLengPerOne="10"
				slot="pagination"
				@to="search($event.offset)"
			/>
		</ManagingSection>
		<section data-app>
			<VDialog v-model="AdDailySingleToggle" scrollable max-width="400">
				<AdDailySingle :id="selectedAdId" />
			</VDialog>
		</section>
	</div>
</template>
<script>
	import moment from 'moment';
	import Excel from 'exceljs';
	import { mapState, mapGetters } from 'vuex';
	import { getImagePath } from '@/util';
	import AdService from '@/lib/AdService';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import Selector from '@/components/Selector.vue';
	import DateRange from '@/components/DateRange.vue';
	import SearchBrand from '@/components/SearchBrand.vue';
	import CategorySelector from '@/components/product/CategorySelector.vue';
	import SortHeader from '@/components/cast/EditorPickListSortHeader.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import AdDailySingle from '@/components/AdDailySingle.vue';
	import Draggable from 'vuedraggable';

	export default {
		name: 'CastList',
		components: {
			ManagingSection,
			ManagingBox,
			Selector,
			DateRange,
			SearchBrand,
			CategorySelector,
			SortHeader,
			PaginationBox,
			AdDailySingle,
			Draggable,
		},
		data() {
			const displayStateList = [
				{ value: null, name: '전체' },
				{ value: 0, name: '노출' },
				{ value: 1, name: '대기' },
				{ value: 2, name: '미노출' },
			];
			const searchTypeList = [
				{ value: 'title', name: '제목' },
				{ value: 'idPouch', name: '항번' },
			];
			const pdtSearchTypeList = [
				{ value: 'productTitle', name: '제품명' },
				{ value: 'idProduct', name: '항번' },
			];
			const sortList = [
				{ value: 11, name: '전시순' },
				{ value: 1, name: '최근등록순' },
				{ value: 2, name: '이전등록순' },
				{ value: 3, name: '전시우선순' },
				{ value: 4, name: '종료우선순' },
				{ value: 5, name: '카테고리순' },
				{ value: 6, name: '카테고리역순' },
				{ value: 7, name: '관심많은순' },
				{ value: 8, name: '관심적은순' },
				{ value: 9, name: '댓글많은순' },
				{ value: 10, name: '댓글적은순' },
				{ value: 12, name: '추천많은순' },
				{ value: 13, name: '추천적은순' },
			];
			const limitList = [50, 100, 200, 500, 1000].map(value => ({
				value,
				name: `${value}개씩`,
			}));

			return {
				idPouchCategory: null,
				period: { from: '', to: '' },
				displayStateList,
				displayState: displayStateList[0].value,
				searchTypeList,
				searchType: searchTypeList[0].value,
				searchText: '',
				idRegister: null,
				tags: '',
				pdtSearchTypeList,
				pdtSearchType: pdtSearchTypeList[0].value,
				pdtSearchText: '',
				idBrand: null,
				idFirstCategory: null,
				idSecondCategory: null,
				idThirdCategory: null,
				offset: 0,
				sortList,
				sort: sortList[0].value,
				limitList,
				limit: limitList[0].value,
				status: {
					total: 0,
					active: 0,
					inactive: 0,
				},
				lastParams: null,
				lastReqUrl: '',
				total: 0,
				list: [],
				originList: [],
				thList: [
					{
						id: 'id',
						text: '번호',
					},
					{
						id: 'cate',
						text: '카테고리',
						descValue: 5,
						ascValue: 6,
					},
					{
						id: 'thumb',
						text: '썸네일 이미지',
					},
					{
						id: 'title',
						text: '제목',
					},
					{
						id: 'start-date',
						text: '노출일시',
					},
					{
						id: 'nickname',
						text: '등록자',
					},
					{
						id: 'create-date',
						text: '등록일시',
					},
					{
						id: 'pdt-cnt',
						text: '제품수',
					},
					{
						id: 'interest-cnt',
						text: '관심',
						descValue: 7,
						ascValue: 8,
					},
					{
						id: 'like-cnt',
						text: '좋아요',
						descValue: 12,
						ascValue: 13,
					},
					{
						id: 'commented-cnt',
						text: '댓글',
						descValue: 9,
						ascValue: 10,
					},
					{
						id: 'display',
						text: '노출 상태',
					},
					{
						id: 'cnt',
						text: '조회 / 통계',
					},
					{
						id: 'duplicate',
						text: '복제',
					},
					{
						id: 'delete',
						text: '삭제',
					},
				],
				adsMap: {},
				AdDailySingleToggle: false,
				selectedAdId: null,
			};
		},
		computed: {
			...mapState('env', {
				adminDomain: state => state.adminDomain,
			}),
			...mapGetters(['getListAddNull']),
			castCateList() {
				return this.getListAddNull('castCate');
			},
			castAdminList() {
				return this.getListAddNull('castAdmin');
			},
			parsedStatus() {
				return `검색 결과 ${this.status.total}건 – 활성 ${this.status.active}건 / 비활성 ${this.status.inactive}건`;
			},
		},
		methods: {
			setFilter() {
				const query = this.$route.query;
				this.idPouchCategory = query.hasOwnProperty('idPouchCategory')
					? Number(query.idPouchCategory)
					: this.castCateList[0].id;
				this.period =
					query.hasOwnProperty('startDate') &&
					query.hasOwnProperty('endDate')
						? {
								from: query.startDate,
								to: query.endDate,
							}
						: {
								from: '',
								to: '',
							};
				this.displayState = query.hasOwnProperty('displayState')
					? Number(query.displayState)
					: null;
				this.searchType = query.hasOwnProperty('searchType')
					? query.searchType
					: this.searchTypeList[0].value;
				this.searchText = query.hasOwnProperty('searchText')
					? query.searchText
					: '';
				this.idRegister = query.hasOwnProperty('idRegister')
					? Number(query.idRegister)
					: this.castAdminList[0].id;
				this.tags = query.hasOwnProperty('tags') ? query.tags : '';
				this.pdtSearchType = query.hasOwnProperty('pdtSearchType')
					? query.pdtSearchType
					: this.pdtSearchTypeList[0].value;
				this.pdtSearchText = query.hasOwnProperty('pdtSearchText')
					? query.pdtSearchText
					: '';
				if (query.hasOwnProperty('idBrand')) {
					const idBrand = Number(query.idBrand);
					this.$refs.SearchBrand.setBrandOnlyId(idBrand);
					this.idBrand = idBrand;
				} else {
					this.$refs.SearchBrand.init();
					this.idBrand = null;
				}
				if (query.hasOwnProperty('idFirstCategory')) {
					const args = {};
					args.category1 = Number(query.idFirstCategory);
					if (query.hasOwnProperty('idSecondCategory')) {
						args.category2 = Number(query.idSecondCategory);
					}
					if (query.hasOwnProperty('idThirdCategory')) {
						args.category3 = Number(query.idThirdCategory);
					}
					this.$refs.CategorySelector.setCategory(args);
					this.categoryChange(args);
				} else {
					this.$refs.CategorySelector.init();
					this.categoryChange({});
				}
				this.offset = query.hasOwnProperty('offset')
					? Number(query.offset)
					: 0;
				this.sort = query.hasOwnProperty('sort')
					? Number(query.sort)
					: this.sortList[0].value;
				this.limit = query.hasOwnProperty('limit')
					? Number(query.limit)
					: this.limitList[0].value;
			},
			paramsFromFilter() {
				const params = {};
				if (typeof this.idPouchCategory === 'number') {
					params.idPouchCategory = this.idPouchCategory;
				}
				if (this.period.from && this.period.to) {
					params.startDate = moment(
						this.period.from,
						'YYYY-MM-DD'
					).format('YYYYMMDD000000');
					params.endDate = moment(
						this.period.to,
						'YYYY-MM-DD'
					).format('YYYYMMDD235959');
				}
				if (typeof this.displayState === 'number') {
					params.displayState = this.displayState;
				}
				if (this.searchText) {
					params[this.searchType] = this.searchText;
				}
				if (typeof this.idRegister === 'number') {
					params.idRegister = this.idRegister;
				}
				if (this.tags) {
					params.tags = this.tags;
				}
				if (this.pdtSearchText) {
					params[this.pdtSearchType] = this.pdtSearchText;
				}
				if (this.idBrand) {
					params.idBrand = this.idBrand;
				}
				if (this.idFirstCategory) {
					params.idFirstCategory = this.idFirstCategory;
					if (this.idSecondCategory) {
						params.idSecondCategory = this.idSecondCategory;
						if (this.idThirdCategory) {
							params.idThirdCategory = this.idThirdCategory;
						}
					}
				}
				params.offset = this.offset;
				params.sort = this.sort;
				params.limit = this.limit;

				return params;
			},
			async getList(params) {
				const {
					data,
					config: { url: reqUrl },
				} = await this.$axiosNoah.get('/pouch', { params });
				const { ads } = await AdService.getTargetAdList(
					'GP0038',
					_.map(data.pouchList, 'idPouch')
				);
				this.adsMap = ads.reduce((acc, cur) => {
					acc[cur.ref_id] = cur;
					return acc;
				}, {});
				this.lastParams = params;
				this.lastReqUrl = reqUrl;
				return {
					total: data.contentTotal,
					list: data.pouchList.map(item => {
						const { display_count, action_count } =
							this.adsMap[item.idPouch] || {};
						return [
							{
								id: this.thList[0].id,
								conts: item.idPouch,
								orderNum: item.orderNum,
							},
							{
								id: this.thList[1].id,
								conts: item.pouchCategoryText,
							},
							{
								id: this.thList[2].id,
								src: getImagePath(
									item.fileDir,
									item.fileSaveName
								),
							},
							{
								id: this.thList[3].id,
								conts: item.pouchTitle,
								link: `/cast/${item.idPouch}`,
							},
							{
								id: this.thList[4].id,
								conts: item.startDate
									? moment(
											item.startDate,
											'YYYYMMDDHHmmss'
										).format('YYYY-MM-DD HH:mm:ss')
									: null,
							},
							{ id: this.thList[5].id, conts: item.nickName },
							{
								id: this.thList[6].id,
								conts: moment(
									item.createDate,
									'YYYYMMDDHHmmss'
								).format('YYYY-MM-DD HH:mm:ss'),
							},
							{ id: this.thList[7].id, btnTxt: item.productCnt },
							{
								id: this.thList[8].id,
								btnTxt: item.castInterestCount,
							},
							{
								id: this.thList[9].id,
								btnTxt: item.castLikeCount,
							},
							{ id: this.thList[10].id, btnTxt: item.commentCnt },
							{
								id: this.thList[11].id,
								conts: item.isDisplay
									? item.startDate &&
										item.startDate >
											moment().format('YYYYMMDDHHmmss')
										? '대기'
										: '노출'
									: '미노출',
							},
							{
								id: this.thList[12].id,
								btnTxt: display_count || action_count || 0,
							},
							{ id: this.thList[13].id },
							{ id: this.thList[14].id },
						];
					}),
					status: data.status,
				};
			},
			async setList() {
				try {
					const params = this.paramsFromFilter();
					const { total, list, status } = await this.getList(params);
					this.total = total;
					this.list = list;
					this.originList = list;
					this.status = status;
				} catch (err) {
					console.error(err);
					alert(
						'캐스트 리스트 로드 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
			idBrandChange({ idBrand }) {
				this.idBrand = idBrand;
			},
			categoryChange({ category1, category2, category3 }) {
				this.idFirstCategory = category1;
				this.idSecondCategory = category2;
				this.idThirdCategory = category3;
			},
			queryFromFilter() {
				const query = {};
				if (typeof this.idPouchCategory === 'number') {
					query.idPouchCategory = this.idPouchCategory;
				}
				if (this.period.from && this.period.to) {
					query.startDate = this.period.from;
					query.endDate = this.period.to;
				}
				if (typeof this.displayState === 'number') {
					query.displayState = String(this.displayState);
				}
				if (this.searchTypeList[0].value !== this.searchType) {
					query.searchType = this.searchType;
				}
				if (this.searchText) {
					query.searchText = this.searchText;
				}
				if (typeof this.idRegister === 'number') {
					query.idRegister = this.idRegister;
				}
				if (this.tags) {
					query.tags = this.tags;
				}
				if (this.pdtSearchTypeList[0].value !== this.pdtSearchType) {
					query.pdtSearchType = this.pdtSearchType;
				}
				if (this.pdtSearchText) {
					query.pdtSearchText = this.pdtSearchText;
				}
				if (this.idBrand) {
					query.idBrand = this.idBrand;
				}
				if (this.idFirstCategory) {
					query.idFirstCategory = this.idFirstCategory;
					if (this.idSecondCategory) {
						query.idSecondCategory = this.idSecondCategory;
						if (this.idThirdCategory) {
							query.idThirdCategory = this.idThirdCategory;
						}
					}
				}
				if (this.offset > 0) {
					query.offset = this.offset;
				}
				if (this.sortList[0].value !== this.sort) {
					query.sort = this.sort;
				}
				if (this.limitList[0].value !== this.limit) {
					query.limit = this.limit;
				}

				return query;
			},
			search(offset = 0) {
				this.offset = typeof offset === 'number' ? offset : 0;
				const query = this.queryFromFilter();
				this.$router.replace({ query }).catch(() => {});
				this.setList();
			},
			init() {
				this.$router.replace({ query: {} }).catch(() => {});
				this.setFilter();
			},
			async downExcel() {
				try {
					const params = {
						...this.lastParams,
						isCsvDownload: true,
					};
					const { list } = await this.getList(params);
					const copyList = [...list];
					const copyThList = [...this.thList];
					const workbook = new Excel.Workbook();
					workbook.creator = '글로우픽';
					workbook.lastModifiedBy = '글로우픽';
					workbook.created = new Date();
					workbook.modified = new Date();
					const sheet = workbook.addWorksheet('one');
					copyThList.splice(2, 1);
					copyThList.splice(12, 2);
					sheet.columns = copyThList.map(({ text }, idx) => ({
						header: text,
						key: idx,
					}));
					sheet.addRows(
						copyList.map(tdList => {
							tdList.splice(2, 1);
							tdList.splice(12, 2);
							return tdList.map(td => td.conts || td.btnTxt);
						})
					);
					const data = await workbook.xlsx.writeBuffer();
					const blob = new Blob([data], {
						type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
					});
					const url = window.URL.createObjectURL(blob);
					const anchor = document.createElement('a');
					anchor.href = url;
					anchor.download = `글로우픽_캐스트목록_${new Date().getTime()}.xlsx`;
					anchor.click();
					window.URL.revokeObjectURL(url);
					await this.$axiosSupport.post('/admin/admin_log', {
						admin_log: {
							path: this.$router.currentRoute.fullPath,
							action: 'CSV',
							doc: { 'api-url': this.lastReqUrl },
						},
					});
				} catch (err) {
					console.error(err);
					alert('엑셀 다운 실패했습니다. 개발팀에 문의하세요.');
				}
			},
			sortChange(sort) {
				this.sort = sort;
				this.search();
			},
			modalId(type) {
				const name = type.split('-')[0].split('');
				name[0] = name[0].toUpperCase();
				return `Cast${name.join('')}User`;
			},
			clickCellBtn(type, id, title) {
				if (type === 'daily') {
					this.selectedAdId = this.adsMap[id].id;
					this.AdDailySingleToggle = true;
					return;
				}
				const payload = {};
				if (type === 'pdt-cnt') {
					payload.id = 'CastPdtList';
					payload.params = { id };
				} else if (
					['interest-cnt', 'like-cnt', 'commented-cnt'].includes(type)
				) {
					payload.id = this.modalId(type);
					payload.params = { castId: id, castTitle: title };
				} else if (type === 'cnt') {
					payload.id = 'AdDetailTotal';
					payload.contsTitle = `${title} 조회 / 통계`;
					payload.params = { id: this.adsMap[id].id };
				}
				this.$store.commit('modal/toggleModal', payload);
			},
			async duplicate(id) {
				try {
					const { data } = await this.$axiosNoah.get(`/pouch/${id}`);
					data.isDisplay = false;
					data.startDate = null;
					data.bestEndOn = null;
					data.bestStartOn = null;
					data.isBest = 0;
					data.products = data.products.map(item => item.idProduct);
					await this.$axiosNoah.post('/pouch', data);
					alert('복제 성공!');
					this.setList();
				} catch (err) {
					console.error(err);
					alert('캐스트 복제 실패했습니다. 개발팀에 문의하세요.');
				}
			},
			async deleting(id) {
				try {
					if (!confirm(`${id} 캐스트 삭제 하겠습니까?`)) return;
					await this.$axiosNoah.delete(`/pouch/${id}`);
					this.setList();
					alert('캐스트 삭제 성공했습니다.');
				} catch (err) {
					console.error(err);
					alert('캐스트 삭제 실패했습니다.');
				}
			},
			async modifyCastOrder() {
				try {
					const changeList = [];
					this.list.forEach((item, index) => {
						if (item[0].conts !== this.originList[index][0].conts) {
							changeList.push({
								idPouch: item[0].conts,
								orderNum: this.originList[index][0].orderNum,
							});
						}
					});

					if (changeList.length > 0) {
						await this.$axiosAdmin2.put(
							'/admin-api/v2/pouch/orderNum',
							{ items: changeList }
						);
						this.setList();
					}
				} catch (err) {
					console.error(err);
					alert('순서를 설정하는데 실패했습니다.');
				}
			},
			async endDrag() {
				if (!confirm('순서를 변경하시겠습니까?')) {
					return (this.list = [...this.originList]);
				}
				await this.$nextTick();
				await this.modifyCastOrder();
			},
		},
		watch: {
			AdDailySingleToggle(v) {
				if (!v) {
					this.selectedAdId = null;
				}
			},
		},
		mounted() {
			this.setFilter();
			this.setList();
		},
	};
</script>
<style lang="scss" scoped>
	.cast-list {
		&__filter-section-2 {
			padding-top: 0 !important;
		}

		&__status {
			font-weight: 700;
		}

		&__table-cell--id {
			width: 60px;
			padding: 0;
		}

		&__table-cell--cate {
			width: 120px;
		}

		&__table-cell--thumb {
			width: 120px;
			padding: 0;
		}

		&__table-cell--start-date {
			width: 100px;
			padding: 0;
		}

		&__table-cell--nickname {
			width: 60px;
			padding: 0;
		}

		&__table-cell--create-date {
			width: 100px;
			padding: 0;
		}

		&__table-cell--pdt-cnt {
			width: 100px;
			padding: 0;
		}

		&__table-cell--interest-cnt {
			width: 100px;
			padding: 0;
		}

		&__table-cell--like-cnt {
			width: 100px;
			padding: 0;
		}

		&__table-cell--commented-cnt {
			width: 100px;
			padding: 0;
		}

		&__table-cell--display-cnt {
			width: 66px;
			padding: 0;
		}

		&__table-cell--cnt {
			width: 120px;
			padding-left: 0;
			padding-right: 0;
		}

		&__table-cell--duplicate {
			width: 70px;
			padding-left: 0;
			padding-right: 0;
		}

		&__table-cell--delete {
			width: 70px;
			padding-left: 0;
			padding-right: 0;
		}

		&__daily-button {
			margin-top: 12px;
		}

		.section__info__text {
			margin-top: 10px;
			font-weight: 400;
			color: #ff3a1c;
		}
		.section__info__left {
			display: block;
		}
	}
</style>
